<template>
<div :class="mobile ? 'mobile-enseigne' : 'inline-enseigne'">
   <div v-for="(g, index) in group" :key="'group-'+index" :class="mobile ? 'item-enseigne-mobile' : 'item-enseigne'">
        <v-chip
          :color="isActive(g) ? 'primary' : 'default'"
          :outlined="!isActive(g)"
          :label="!mobile"
          @click="setGroup(g)"
          :class="mobile ? 'enseigne-chip-mobile' : 'enseigne-chip'"
          :large="mobile"
        >
          <v-icon :small="!mobile" class="mr-2">
            {{ getEnseigneIcon(g.val) }}
          </v-icon>
          {{ g.name }}
        </v-chip>
      </div>
</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeFilters: [] // Tableau des filtres actifs
    }
  },
     computed: {
    ...mapState({
      enseignes: state => state.enseignes.all,
      selected: state => state.enseignes.current,
      context: state => state.enseignes.context,
      coordsPoissonnerie: state => state.enseignes.coordsPoissonnerie,
      coordsBoucherie: state => state.enseignes.coordsBoucherie
    }),
    group() {
      const intermarche = this.enseignes.filter(enseigne => enseigne.enseigne.includes('Intermarché'))
      const superu = this.enseignes.filter(enseigne => enseigne.enseigne.includes('Super U'))
      const leclerc = this.enseignes.filter(enseigne => enseigne.enseigne.includes('E.Leclerc'))
      const indépendant = this.enseignes.filter(enseigne => enseigne.enseigne.includes('Indépendant'))
      const carrefour = this.enseignes.filter(enseigne => enseigne.enseigne.includes('Carrefour'))
      return [
        {name:`Tous (${this.enseignes.length})`,val:'All',  stores: this.enseignes},
        {name:`Intermarché (${intermarche.length})`, val:'Int', stores: intermarche},
        {name:`Super U (${superu.length})`,val:'Sup',  stores: superu},
        {name:`E.Leclerc (${leclerc.length})`,val:'Lec',  stores: leclerc},
        {name:`Carrefour (${carrefour.length})`,val:'Car',  stores: carrefour},
        {name:`Indépendant (${indépendant.length})`,val:'Ind',  stores: indépendant},
        ]
    }
  },
  watch: {
    context() {
      // Les filtres sont réinitialisés dans le store au changement de contexte
      this.activeFilters = []
    }
  },
  methods:{
    setGroup(value) {
      // Gestion du filtre "Tous"
      if (value.val === 'All') {
        this.activeFilters = []
        this.$store.dispatch('setCentraleType', '')
        this.$store.dispatch('setEnseigneFilters', [])
        return
      }

      // Toggle du filtre
      const index = this.activeFilters.findIndex(f => f.val === value.val)
      if (index > -1) {
        // Retirer le filtre
        this.activeFilters.splice(index, 1)
      } else {
        // Ajouter le filtre
        this.activeFilters.push(value)
      }

      // Mettre à jour le store avec les valeurs des filtres
      const filterValues = this.activeFilters.map(f => f.val)
      this.$store.dispatch('setEnseigneFilters', filterValues)

      // Gérer les polygones : afficher si un seul filtre Leclerc
      if (this.activeFilters.length === 1 && this.activeFilters[0].val === 'Lec') {
        this.$store.dispatch('setCentraleType', 'Lec')
      } else {
        this.$store.dispatch('setCentraleType', '')
      }
    },
    isActive(g) {
      if (g.val === 'All') {
        return this.activeFilters.length === 0
      }
      return this.activeFilters.some(f => f.val === g.val)
    },
    getEnseigneIcon(val) {
      const icons = {
        'All': 'mdi-storefront',
        'Int': 'mdi-store',
        'Sup': 'mdi-store',
        'Lec': 'mdi-store',
        'Car': 'mdi-store',
        'Ind': 'mdi-store-marker'
      }
      return icons[val] || 'mdi-store'
    }
  }
}

</script>
<style lang="scss" scoped>
.inline-enseigne{
  display: inline-flex;
  align-items: center;
  padding: 2px;
  gap: 8px;
  flex-wrap: wrap;
}

.item-enseigne {
  margin-left: 8px;
  margin-top: 4px;
}

.enseigne-chip {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 13px;
  height: 36px !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
}

::v-deep .v-chip__content {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

/* Mobile Styles */
.mobile-enseigne {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.item-enseigne-mobile {
  width: 100%;
}

.enseigne-chip-mobile {
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
  font-size: 15px;
  width: 100%;
  height: 48px !important;
  justify-content: flex-start;
  
  &:active {
    transform: scale(0.98);
  }
  
  ::v-deep .v-chip__content {
    width: 100%;
    justify-content: flex-start;
    padding: 0 16px;
  }
}
</style>
